import { addIntegration, browserTracingIntegration, init, setUser as setSentryUser } from "@sentry/vue";
import type { App } from "vue";
import router from "../router";

export function initSentry(app: App, dsn: string, environment: string) {
    if (!dsn) {
        console.warn("Sentry DSN is not provided, Sentry will not be initialized");
        return;
    }

    init({
        app, // Vue 应用实例
        dsn, // Sentry 数据源名称，用于连接到 Sentry 服务
        environment, // 环境名称，用于区分不同的部署环境
        // 设置为 true 将发送默认的个人身份信息(PII)数据到 Sentry
        // 例如，事件上的自动 IP 地址收集
        sendDefaultPii: true,
        integrations: [ // 集成模块
            browserTracingIntegration({ router }), // 浏览器追踪集成，与 Vue Router 关联
        ],
        // Tracing 追踪设置
        tracesSampleRate: 1.0, // 捕获 100% 的事务
        // 设置 'tracePropagationTargets' 来控制哪些 URL 应启用分布式追踪
        tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/], // 本地开发和特定 API 服务器

        // Session Replay 会话回放设置
        replaysSessionSampleRate: 0.0, // 设置会话采样率为 10%。在开发环境中可能需要设为 100%，而在生产环境中使用较低的采样率
        replaysOnErrorSampleRate: 0.1, // 如果没有对整个会话进行采样，则在发生错误的会话中将采样率更改为 100%

        // Logs 日志设置
        enableLogs: true, // 启用 Sentry 日志记录功能

        denyUrls: [
            // 屏蔽来自浏览器插件的错误
            /extensions\//i, /^chrome:\/\//i, /safari-extension:/i
        ],
    });

    console.log(`Sentry initialized in ${environment} environment`);
}

// 异步加载回放模块
export async function initSentryReplay() {
    const { replayIntegration } = await import('@sentry/vue');
    setTimeout(() => {
        addIntegration(replayIntegration());
    });
}

// 设置用户信息
export function setUser(user: {
    id: string;
    username?: string;
    email?: string;
}) {
    setSentryUser(user);
}

// 清除用户信息（如用户登出时）
export function clearUser() {
    setSentryUser(null);
}
